import { createColumnHelper } from '@tanstack/react-table';
import type { ColumnDef } from '@tanstack/react-table';
import _ from 'lodash';
import type { ColumnConfig } from '../../dev-express/types/table.types';
import type {
  AccessorFunctionType,
  ColumnFilters,
  Columns,
  InternalColumnHelper,
} from '../types';

export const tanstackColumnAdaptor = (
  cols: ColumnConfig<any, any> | undefined
): AccessorFunctionType[] | null => {
  const columnHelper = extractColumnHelper();

  if (!cols) {
    return null;
  }

  return Object.values(cols).map((col) => {
    return columnHelper.accessor(String(col.name), {
      header: col.title,
      ...(col.getCellValue && {
        cell: (row) => col.getCellValue?.(row.cell.row.original, null),
      }),
      enableHiding: col.canToggle,
      enableSorting: col.sort,
      size: getColSize(col.width),
      isVisible: col.show ?? true,
      filterType: col.filterType,
    });
  });
};

function getColSize(width: string | number | undefined) {
  if (!width) {
    return 200;
  }

  if (_.isNumber(width)) {
    return width;
  }

  return COL_WIDTHS[width as keyof typeof COL_WIDTHS] ?? 200;
}

const COL_WIDTHS = {
  xxs: 50,
  xs: 80,
  s: 120,
  m: 230,
  l: 255,
};

export function deriveColumnVisibility(columns: ColumnDef<any, any>[]) {
  return columns.reduce((acc, col) => {
    return {
      ...acc,
      // @ts-expect-error TS(2339): Property 'accessorKey' does not exist on type 'Col... Remove this comment to see the full error message
      [col.accessorKey as string]: col.isVisible ?? true,
    };
  }, {});
}

export function extractColumnHelper<T = any>() {
  return createColumnHelper() as InternalColumnHelper<T>;
}

export const prepColumnFilters = (cols: Columns) => {
  return cols.reduce<ColumnFilters>((acc, col) => {
    if (col.filterType) {
      return {
        ...acc,
        [col.accessorKey]: {
          text: col.header,
          type: col.filterType,
          getListOptions: col.getListOptions,
          key: col.accessorKey,
        },
      };
    }

    return acc;
  }, {} as ColumnFilters);
};
